export default __webpack_public_path__ + "static/pwa-71de2aed47a6cf52c4bc2ed4405cb1d0.png";